"use client";

import {
  ApolloNextAppProvider,
  ApolloClient,
} from "@apollo/client-integration-nextjs";
import { errorLink, httpLink, cache } from "./options";
import { from } from "@apollo/client";

function makeClient() {
  return new ApolloClient({
    link: from([errorLink, httpLink]),
    cache,
  });
}

export function ApolloProvider({ children }: React.PropsWithChildren) {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      {children}
    </ApolloNextAppProvider>
  );
}
